import { useEffect, useState } from "react";

// Models
import ICarouselDTO from "../../../../Models/DTOs/ICarouselDTO";
import ICarouselContentDTO from "../../../../Models/DTOs/ICarouselContentDTO";

// Api
import {GetTopRatedVideos} from "../../../../Api/Video";

// Helpers
import {transformVideoToCarouselContent} from "../../../../Helpers/DataConversion/ConvertToCarouselContentItem";

function useFetchTopRated(take: number = 12) {
    const
        [topRated, setTopRated] = useState<ICarouselContentDTO[] | undefined>(undefined),
        [topRatedLoading, setTopRatedLoading] = useState(false),
        [topRatedError, setTopRatedError] = useState("");

    useEffect(() => {
        let isCancelled = false;

        setTopRatedLoading(true);
        setTopRatedError("");

        (async () => {
            try {
                const data = await GetTopRatedVideos({ take }); // CountWrapper<VideoDTO>

                if (isCancelled) return;

                const items: ICarouselContentDTO[] = (data.items ?? []).map(transformVideoToCarouselContent);

                setTopRated(items);
            } catch (err) {
                if (!isCancelled) {
                    console.error(err);
                    setTopRatedError("Failed to fetch top rated carousel.");
                }
            } finally {
                if (!isCancelled) {
                    setTopRatedLoading(false);
                }
            }
        })();

        return () => {
            isCancelled = true;
        };
    }, [take]);

    return { topRated, topRatedLoading, topRatedError };
}

export default useFetchTopRated;
